import { useState } from "react";
import { Input, Checkbox, Button, Spin, Empty } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import trans from "../../../utils";

export default function InfiniteSelectFilterDropdown({
	selectedKeys,
	setSelectedKeys,
	confirm,
	clearFilters,
	useOptions,
	searchPlaceholder,
}) {
	const [search, setSearch] = useState("");
	const { options, isFetching, loadMore } = useOptions(search);

	const handleScroll = (e) => {
		const { target } = e;
		if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 10) {
			loadMore();
		}
	};

	const toggle = (value, checked) => {
		setSelectedKeys(
			checked
				? [...selectedKeys, value]
				: selectedKeys.filter((k) => k !== value),
		);
	};

	return (
		<div style={{ width: 240 }} onKeyDown={(e) => e.stopPropagation()}>
			<div style={{ padding: 8 }}>
				<Input
					prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
					placeholder={searchPlaceholder || trans("Search in filters")}
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					allowClear
				/>
			</div>
			<div
				style={{ maxHeight: 260, overflowY: "auto", padding: "0 8px" }}
				onScroll={handleScroll}
			>
				{options.map((opt) => (
					<div key={opt.value} style={{ padding: "5px 4px" }}>
						<Checkbox
							checked={selectedKeys.includes(opt.value)}
							onChange={(e) => toggle(opt.value, e.target.checked)}
						>
							{opt.label}
						</Checkbox>
					</div>
				))}
				{isFetching && (
					<div style={{ textAlign: "center", padding: 8 }}>
						<Spin size="small" />
					</div>
				)}
				{!isFetching && !options.length && (
					<Empty
						image={Empty.PRESENTED_IMAGE_SIMPLE}
						description={trans("No data")}
						style={{ margin: "12px 0" }}
					/>
				)}
			</div>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					padding: "7px 8px",
					borderTop: "1px solid #f0f0f0",
				}}
			>
				<Button
					type="link"
					size="small"
					disabled={!selectedKeys.length}
					onClick={() => {
						clearFilters?.();
						confirm();
					}}
				>
					{trans("Reset")}
				</Button>
				<Button type="primary" size="small" onClick={() => confirm()}>
					{trans("OK")}
				</Button>
			</div>
		</div>
	);
}
